import React, { Component, Fragment } from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import { Send } from '../../lazy-components'
import glamorous from 'glamorous'
import { smallAndSmaller } from '../../../lib/styles/media-queries'
import DocumentTitle from 'react-document-title'
import { Icon } from '@paypalcorp/pp-react'
import { ANALYTICS_FLOW_TYPE } from '../../../../../lib/constants'
import { MGM } from '../../constants'
import { setMgmTrackingCommonProps } from 'transfer/utils/mgmUtils'
import { tracking } from 'lib/analytics/mParticle'
import Events from 'lib/analytics/eventTags'
import { get, isEmpty } from 'lodash'
import { showErrorPage } from '../../actions/Actions'

export const MGMLandingContainer = glamorous.div('col-md-8', {
  overflow: 'hidden',
  position: 'static',
  borderRadius: '3px',
  zIndex: '2',
  overflowX: 'visible',
  marginTop: '2%',
  marginBottom: '3%',
  backgroundColor: 'white',
  [smallAndSmaller]: {
    marginTop: '5%',
  },
})

export const MGMTitleDiv = glamorous.div({
  textAlign: 'center',
  margin: '1.5rem',
  display: 'block',
  justifyContent: 'center',
  color: '#2C2E2F',
  fontSize: '24px',
  fontFamily: 'PayPal Sans Big',
  [smallAndSmaller]: {
    margin: '1rem',
  },
})

export const MGMDescriptionDiv = glamorous.div({
  textAlign: 'center',
  margin: '1.5rem',
  display: 'block',
  justifyContent: 'center',
  color: '#2C2E2F',
  fontFamily: 'PayPal Sans Big',
  fontSize: '16px',
  [smallAndSmaller]: {
    margin: '1rem',
  },
})

const Link = glamorous.a('ppvx_link', {
  cursor: 'pointer',
})

export const MGMWrapper = glamorous.div({
  display: 'block',
  backgroundColor: 'white',
  width: '100%',
})

export const LinkWrapper = glamorous.div({
  marginTop: '1%',
})

export const MGMLandingImage = glamorous.img({
  height: 'auto',
  width: '100%',
})

export const MGMRow = glamorous.div({
  display: 'block',
  width: '100%',
  backgroundColor: 'white',
  justifyContent: 'center',
  marginTop: '1.5rem',
  [smallAndSmaller]: {
    marginTop: '1rem',
  },
})

export const MGMColumn = glamorous.div({
  display: 'inline-block',
  width: '30%',
  verticalAlign: 'center',
  justifyContent: 'center',
  margin: '0.5rem',
  [smallAndSmaller]: {
    width: '100%',
    margin: '0.2rem 0.2rem 1rem 0.2rem',
  },
})

export const ColumnText = glamorous.div({
  color: '#2C2E2F',
  fontSize: '14px',
  margin: '0.5rem auto auto auto',
  textAlign: 'center',
  width: '130px',
  [smallAndSmaller]: {
    width: '100%',
  },
})

export const IconContainer = glamorous.div({
  display: 'block',
  margin: 'auto',
  height: '36px',
  width: '36px',
})

type MGMProps = {
  currencyCode: string,
  timeZone: string,
  isUserCountryUS: String,
  pStudioContent: any,
  dispatch: any,
}

export class MgmLandingPage extends Component<MGMProps> {
  componentDidMount() {
    setMgmTrackingCommonProps(window.location.href)
    tracking(Events.p2p_mgm_interstitial_screen_shown())
  }

  render = () => {
    const mgmPSContent = get(
      this.props.pStudioContent,
      'mgm_referrer_1c_flow_touchpoint.content.json',
      {}
    )

    if (isEmpty(mgmPSContent)) {
      this.props.dispatch(showErrorPage('mgm-ps-error'))
      return null
    }

    return (
      <DocumentTitle title={mgmPSContent.page_doc_title}>
        <Fragment>
          <MGMLandingContainer className="col-md-offset-2">
            <MGMWrapper>
              <MGMTitleDiv>{mgmPSContent.page_image_title}</MGMTitleDiv>
              <MGMLandingImage
                alt={mgmPSContent.page_image_alt}
                src={mgmPSContent.web_page_image_url}
              />

              <MGMRow>
                <MGMColumn>
                  <IconContainer>
                    <Icon name="tip-jar" size="lg" />
                  </IconContainer>
                  <ColumnText>{mgmPSContent.description_1}</ColumnText>
                </MGMColumn>
                <MGMColumn>
                  <IconContainer>
                    <Icon name="user" size="lg" />
                  </IconContainer>
                  <ColumnText>{mgmPSContent.description_2}</ColumnText>
                </MGMColumn>
                <MGMColumn>
                  <IconContainer>
                    <Icon name="add-cash" size="lg" />
                  </IconContainer>
                  <ColumnText>{mgmPSContent.description_3}</ColumnText>
                </MGMColumn>
              </MGMRow>

              <MGMDescriptionDiv>
                <LinkWrapper>
                  {mgmPSContent.description_4}
                  <Link
                    data-pagename={'main:p2p:mgm:landing'}
                    href={mgmPSContent.terms_and_condition_url}
                    target="_blank"
                    onClick={() => tracking(Events.p2p_mgm_terms_pressed())}
                  >
                    {mgmPSContent.terms_and_condition}
                  </Link>
                </LinkWrapper>
              </MGMDescriptionDiv>
            </MGMWrapper>
          </MGMLandingContainer>
          <Send productFlowId={ANALYTICS_FLOW_TYPE.MGM} />
        </Fragment>
      </DocumentTitle>
    )
  }
}
export default connect(({ amount, user, server }) => ({
  currencyCode: amount.currencyCode,
  timeZone: user.timeZone,
  isUserCountryUS: user.country === MGM.US_COUNTRY_CODE,
  pStudioContent: server.pStudioContent,
}))(MgmLandingPage)
